// The transport of the letters above the section «Письма» (platform П10): the person sees whether the letters leave at all.
// Only the transport and the sender's address come from the server — the host, the port and the password stay there.

import { useSync } from '../sync/react.tsx';
import s from './mail.module.css';

export function MailTransportNotice() {
  const client = useSync();
  const mail = client.header?.mail;
  if (!mail) return null;
  if (mail.transport === 'smtp') {
    return <div className={`${s.notice} ${s.info}`}>Письма уходят через почтовый сервер. Отправитель: {mail.from ?? '—'}</div>;
  }
  return <div className={`${s.notice} ${s.warn}`}>Почта не настроена: письма сохраняются здесь и не уходят адресатам.</div>;
}
